"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveMember = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var myPage_1 = require("../../model/myPage");
var service_1 = require("../../../library/base/service");
var ActiveMember = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ActiveMember, _super);
    function ActiveMember() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '激活尊享会员卡';
        _this.code = '101112';
        _this.desc = '激活尊享会员卡';
        _this.requestParams = new myPage_1.ActiveMemberRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ActiveMember;
}(service_1.BaseService));
exports.ActiveMember = ActiveMember;
//# sourceMappingURL=activeMember.js.map